import useCurrency from '@/app/hooks/useCurrency';
import { useProductsData } from '@/queries/Products';
import getProductListPriceRange from '@/utils/getProductListPriceRange';

import type { BaseStoreRingData } from '../_types/types';

const useRingCarouselData = ({
  baseData,
}: {
  baseData: BaseStoreRingData[];
}) => {
  const { currencyCode } = useCurrency();
  const { data: productsQueryData } = useProductsData({
    includeInventory: false,
  });

  const products = baseData.map((baseProduct) => {
    const matchingProductFromQuery = productsQueryData?.find(
      (p) => p.productKey === baseProduct.productKey,
    );

    return {
      ...baseProduct,
      priceInfo: {
        discountedPrice:
          matchingProductFromQuery?.discountedPrice.discountedPrice?.amount,
        basePrice: matchingProductFromQuery?.price?.amount,
        currencyCode,
      },
    };
  });

  const prices = products.map(
    ({ priceInfo: { discountedPrice, basePrice } }) => ({
      discountedPrice,
      basePrice,
    }),
  );
  const priceRange = getProductListPriceRange(prices);

  return {
    products,
    priceRange,
  };
};

export default useRingCarouselData;
